export default __webpack_public_path__ + "static/media/UPIIcon.555db684.svg";